import { BASELINES, ANSWER_VALUES_MAP } from './constants'

const getValues = (answers, section, isNote) => {
  const hasWill = answers[0] === 'yes'

  return answers
    .map((answer, index) => {
      if (ANSWER_VALUES_MAP[index][hasWill]) {
        return isNote
          ? ANSWER_VALUES_MAP[index][hasWill][answer].notes?.[section]
          : ANSWER_VALUES_MAP[index][hasWill][answer][section]
      }
      return isNote
        ? ANSWER_VALUES_MAP[index][answer].notes?.[section]
        : ANSWER_VALUES_MAP[index][answer][section]
    })
    .filter((value) => !!value)
}

export const calculateEstimates = (answers) =>
  ['probateMin', 'probateMax', 'estateAdminMin', 'estateAdminMax'].reduce(
    (estimates, section) => {
      const values = getValues(answers, section)
      return {
        ...estimates,
        [section]: values.length
          ? Math.max(...values) + BASELINES[section]
          : BASELINES[section],
      }
    },
    {}
  )

export const getNotes = (answers) =>
  ['probate', 'estateAdmin'].reduce(
    (notes, section) => ({
      ...notes,
      [section]: getValues(answers, section, true),
    }),
    {}
  )
